module.exports = __webpack_public_path__ + "53bf532c612135308792e1035f27efb2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/avocado-s.png
// module id = 1960
// module chunks = 0